import { Container } from "@mui/material";
import "./styles.css";

const MainContainer = ({ children, className, fluid, ...rest }) => {
  return (
    <section className={`${className} NewDesignWrapper`}>
      <Container {...rest} maxWidth={fluid ? false : rest.maxWidth}>{children}</Container>
    </section>
  );
};

export default MainContainer;
